import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";
import SurveyReportLayout from "./SurveyReportLayout";
import axiosInstance from "../../../../Services/axiosCommon";
import CommonDynamicForm from "../../../../Components/Utils/CommonDynamicForm";
import { useParams } from "react-router-dom";
import { useToast } from "../../../../Components/Others/ToastServices";
import NuDate from "../../../../Components/Utils/NuDate";
import EditIcon from "../../../../Components/Icons/Edit";
import { GetAccess, GetRole } from "../../../../Components/Utils/roles";
import SendOTP from "./SendOTP";
import { SubmitButton } from "../../../../Components/Utils/Buttons";
import SignatureCanvas from "react-signature-canvas";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import CDynamicFormTwo from "../../../../Components/Utils/CDynamicFormTwo";

function FormSurvey() {
  const { surveyReportViewId } = useParams();
  const [editModeIndex, setEditModeIndex] = useState(null);
  const [signOne, setSignOne] = useState(null);
  const [signTwo, setSignTwo] = useState(null);
  const toast = useToast();
  const [filesList, setFileList] = useState([]);
  const [allFormValues, setAllFormValues] = useState([]);
  const [allForm, setAllForm] = useState([]);
  const [allValue, setAllValue] = useState([]);
  const [isSubmittted, setisSubmittted] = useState();
  const [fileRemoveList, setFileRemoveList] = useState([]);
  const [removeSignOne, setRemoveSignOne] = useState("");
  const [removeSignTwo, setRemoveSignTwo] = useState("");

  useEffect(() => {
    if (surveyReportViewId) fetchTasks(surveyReportViewId);
  }, [surveyReportViewId]);

  const fetchTasks = async (value) => {
    try {
      const response = await axiosInstance.get(
        `/survey-report/get-form/${value}`
      );
      const data = response.data?.data;
      setisSubmittted(response?.data?.data?.isFormVerified === false);
      checkAllSubmitted();
      checkOtpEnable();
      console.log("TEST ONE - Data", data);

      if (Array.isArray(data)) {
        setAllFormValues(data);
      } else if (data) {
        setAllFormValues([data]);
      } else {
        setAllFormValues([]);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setAllFormValues([]);
    }
  };

  const [formId, setFormId] = useState(null);

  const fetchAllForm = async (value) => {
    setFormId(value);
    try {
      // setLoading(true);
      const formResponse = await axiosInstance.get(
        `/survey-report/get-form/${value}`
      );
      console.log(formResponse.data?.data);
      setAllForm(formResponse.data?.data);
      let TempArray = [];
      let tempFormData = formResponse.data?.data?.titles || [];
      tempFormData?.forEach((item) => {
        item?.fields?.forEach((field) => {
          console.log("Field - getting", field);
          let ValueInSide = {
            id: field?.id,
            field_type: field?.field_type,
            field_label: field?.field_label,
            value: field?.value,
          };
          TempArray.push(ValueInSide);
        });
      });
      setAllValue(TempArray);
      console.log("Temp Arr", TempArray);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      // setLoading(false);
    }
  };

  const [expandedIndex, setExpandedIndex] = useState(null);
  const [showErrorFeild, setShowErrorFeild] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");

  const handleToggle = (index, id) => {
    setAllForm([]);
    fetchAllForm(id);
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: yup.object({}),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      try {
        const ValuesForForm = {
          isSubmitted: true,
          values: allValue,
          filesToRemove: [],
          oldSign1: removeSignOne || "",
          oldSign2: removeSignTwo || "",
        };
        if (fileRemoveList) {
          ValuesForForm.filesToRemove = fileRemoveList;
        }
        const formData = new FormData();
        formData.append("json_data", JSON.stringify(ValuesForForm));
        filesList &&
          filesList.map((item) => {
            formData.append("attachments", item);
          });
        signOne &&
          formData.append(
            "signature1",
            signOne,
            `signature1-${formId}-${new Date().toISOString()}.png`
          );
        signTwo &&
          formData.append(
            "signature2",
            signTwo,
            `signature2-${formId}-${new Date().toISOString()}.png`
          );

        const res = await axiosInstance.put(
          `/surveyInspectionForm/SIforms/${formId}`,
          formData
        );
        console.log("Form Submitted", res.data);

        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
          CloseEditForm(formId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
          setShowErrorFeild(true);
          setErrorMessage(res.data?.data || "Network error.");
        }
      } catch (err) {
        console.log("err", err);
        toast.open({
          type: "error",
          message: "Error",
          description: err.response?.data?.msg || "Something went wrong.",
        });
      }
    },
  });

  function SaveFormData() {
    let ValuesForForm = {
      isSubmitted: false,
      values: allValue,
      filesToRemove: [],
      oldSign1: removeSignOne || "",
      oldSign2: removeSignTwo || "",
    };
    if (fileRemoveList) {
      ValuesForForm.filesToRemove = fileRemoveList;
    }
    const formData = new FormData();
    formData.append("json_data", JSON.stringify(ValuesForForm));
    filesList &&
      filesList.map((item) => {
        formData.append("attachments", item);
      });
    signOne &&
      formData.append(
        "signature1",
        signOne,
        `signature1-${formId}-${new Date().toISOString()}.png`
      );
    signTwo &&
      formData.append(
        "signature2",
        signTwo,
        `signature2-${formId}-${new Date().toISOString()}.png`
      );

    axiosInstance
      .put(`/surveyInspectionForm/SIforms/${formId}`, formData)
      .then((res) => {
        console.log("Form Submitted", res.data);
        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
          CloseEditForm(formId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        toast.open({
          type: "error",
          message: "Error",
          description: "Something went wrong while submitting the form.",
        });
      });
  }

  const [editLoading, setEditLoading] = useState(false);

  async function CloseEditForm(id) {
    setEditLoading(true);
    await axiosInstance
      .put(`/surveyInspectionForm/close-form/${surveyReportViewId}`)
      .then((res) => {
        if (res?.data?.status) {
          console.log("ok");
          setEditModeIndex(null);
          fetchTasks(surveyReportViewId);
          setEditLoading(false);
        } else {
          console.log("error");
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
          setEditLoading(false);
        }
      })
      .catch((error) => {
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
        setEditLoading(false);
      });
  }

  async function OpenEditForm(index, id, workingUser) {
    if (workingUser) {
      CloseEditForm(id);
    } else {
      setEditLoading(true);
      await axiosInstance
        .put(`/surveyInspectionForm/open-form/${surveyReportViewId}`)
        .then((res) => {
          if (res?.data?.status) {
            fetchTasks(surveyReportViewId);
            setEditModeIndex(editModeIndex === index ? null : index);
            setEditLoading(false);
          } else {
            console.log("error");
            toast.open({
              type: "error",
              message: "Error",
              description: res.data?.msg || "Network error.",
            });
            setEditLoading(false);
          }
        })
        .catch((error) => {
          toast.open({
            type: "error",
            message: "Error",
            description: error?.response?.data?.msg || "Network error.",
          });
          setEditLoading(false);
        });
    }
  }
  const [open, setOpen] = useState(false);

  const handleSendOTP = () => setOpen(true);
  const [allSubmitted, setAllSubmitted] = useState(false);

  const checkAllSubmitted = async () => {
    try {
      const response = await axiosInstance.get(
        `/survey-report/check-submitted/${surveyReportViewId}`
      );
      console.log("Check Submitted Status", response.data);

      if (response.data?.status) {
        setAllSubmitted(response.data.data === true);
      } else {
        console.warn("Unexpected response status:", response.data);
        setAllSubmitted(false);
      }
    } catch (error) {
      console.error("Error checking submission status:", error);
      setAllSubmitted(false);
    }
  };
  useEffect(() => {
    if (surveyReportViewId) {
      checkAllSubmitted();
      fetchTasks(surveyReportViewId);
    }
  }, [surveyReportViewId]);

  const [otpEnable, setOtpEnable] = useState(false);
  const [openEnable, setEnableOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fetch OTP enable status
  const checkOtpEnable = async () => {
    try {
      const response = await axiosInstance.get(`/survey-report/is-otp-enabled`);
      console.log("Check Submitted Status", response.data);

      if (response.data?.status) {
        setOtpEnable(response.data.data === true);
      } else {
        console.warn("Unexpected response status:", response.data);
        setOtpEnable(false);
      }
    } catch (error) {
      console.error("Error checking submission status:", error);
      setOtpEnable(false);
    }
  };

  // On button click, open confirm popup
  const handleEnableOTP = () => setEnableOpen(true);

  // On confirm, call verify API
  const handleVerifyOTP = () => {
    setLoading(true);
    axiosInstance
      .put(`/survey-report/verify-otp/${surveyReportViewId}`, { opt: "" })
      .then((res) => {
        if (res.data.status) {
          toast.open({
            type: "success",
            message: "OTP Verified",
          });
          fetchTasks(surveyReportViewId);
        } else {
          toast.open({
            type: "error",
            message: "Invalid OTP",
            description: res.data.msg,
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Network Error",
          description: err.message,
        });
      })
      .finally(() => {
        setLoading(false);
        setEnableOpen(false);
      });
  };

  // On page load, check status and fetch tasks
  useEffect(() => {
    checkOtpEnable();
    fetchTasks(surveyReportViewId);
  }, [surveyReportViewId]);

  useEffect(() => {
    if (allForm?.signature1?.file) {
      setRemoveSignOne(allForm?.signature1?.file);
    }
    if (allForm?.signature2?.file) {
      setRemoveSignTwo(allForm?.signature2?.file);
    }
  }, [allForm]);

  return (
    <SurveyReportLayout>
      <div className="w-full h-full mt-0.5 overflow-y-auto">
        {
          <div className="w-full mx-auto h-[calc(100vh-175px)] overflow-y-scroll   pb-8">
            {allFormValues?.map((item, index) => {
              return (
                <>
                  <div
                    key={item?.id || index}
                    className="border-b border-gray-300"
                  >
                    <div
                      className="md:flex justify-between items-center p-2  bg-white "
                      // onClick={() => handleToggle(index, item?.id)}
                    >
                      <h1 className="text-sm font-semibold w-[50%]">
                        {item.formName || " - "}
                      </h1>
                      <div className="flex 2xl:w-[50%] md:w-[65%] gap-2 justify-end items-center">
                        <div className="border border-baseColor-primary h-auto w-full bg-gray-50 rounded-lg md:mx-4  md:ml-2 p-2">
                          <div className="md:flex gap-2 w-full">
                            <div className="flex gap-2 w-[50%] ">
                              <table className=" w-full text-xs">
                                <tr className=" w-full">
                                  <td className=" w-[90px] pb-2 font-medium">Inspector</td>
                                  <td className=" w-[5px] pb-2">:</td>
                                  <td className=" pb-2  text-[#606279]">{item?.workingUserName || " "}</td>
                                </tr>
                                <tr>
                                  <td className=" w-[90px]  font-medium">Updated By</td>
                                  <td className=" w-[5px] ">:</td>
                                  <td className="  text-[#606279] font-medium"><div>
                                      <p>{item?.updatedByName || " "}</p>  
                                      
                                      </div>
                                      </td>
                                </tr>
                                 <tr>
                                  <td className=" w-[90px] "></td>
                                  <td className=" w-[5px]"></td>
                                  <td><div>
                                      {
                                        item?.updatedByName && item?.updatedOn && <p className=" text-[10px] text-[#606279]">
                                          <NuDate
                                            value={item?.updatedOn}
                                            format="DD-MMM-YYYY, "
                                          />
                                          {/* <NuDate
                                            value={item?.updatedOn}
                                            format="hh:mm a"
                                          /> */}
                                        </p>
                                      }
                                      </div>
                                      </td>
                                </tr>
                              </table>
                            </div>
                            <div className="flex gap-2 w-[50%] ">
                              <table className=" w-full text-xs">
                                <tr className=" w-full">
                                  <td className=" w-[110px] pb-1 font-medium">Status</td>
                                  <td className=" w-[5px] pb-1">:</td>
                                  <td className=" pb-1  text-[#606279] font-medium">{item?.status || "None"}</td>
                                </tr>
                                <tr>
                                  <td className=" w-[110px]  font-medium">Completion Date</td>
                                  <td className=" w-[5px] ">:</td>
                                  <td className="  text-[#606279] font-medium"><div>
                                      <p>
                                                                          <span>
                                    <NuDate
                                      value={item?.submittedOn}
                                      format="DD-MMM-YYYY, "
                                    />
                                  </span>
                                  {/* <span>
                                    <NuDate
                                      value={item?.submittedOn}
                                      format="hh:mm a"
                                    />
                                  </span> */}
                                  </p>  
                                      
                                      </div>
                                      </td>
                                </tr>
                                 <tr>
                                  <td className=" w-[110px] "></td>
                                  <td className=" w-[5px]"></td>
                                  <td><div>
                                      
                                      </div>
                                      </td>
                                </tr>
                              </table>
                            </div>
                            {/* <div className="flex gap-2 w-[50%] bg-red-300">
                              <div className="w-1/3">
                               
                                  <p className="py-1 text-xs font-medium text-[#111537]">
                                    Inspector
                                  </p>
                               
                                <p className="py-1 text-xs font-medium text-[#111537]">
                                  Updated By
                                </p>
                              </div>
                              <div className="w-[65%]">
                                {item?.workingUser != null && (
                                  <p className="py-1 text-xs font-medium text-[#606279]">
                                    : {item?.workingUserName || "None"}
                                  </p>
                                )}
                                <p className="py-1 text-xs font-medium text-[#606279]">
                                  : {item?.updatedByName || "None"}
                                  <div className="ml-1">
                                    <span>
                                      <NuDate
                                        value={item?.updatedOn}
                                        format="DD-MMM-YYYY, "
                                      />
                                    </span>
                                    <span>
                                      <NuDate
                                        value={item?.updatedOn}
                                        format="hh:mm a"
                                      />
                                    </span>
                                  </div>
                                </p>
                              </div>
                            </div> */}

                            {/* <div className="flex gap-2 w-[50%]">
                              <div className="w-1/3">
                                <p className="py-1 text-xs font-medium text-[#111537]">
                                  Status
                                </p>

                                <p className="py-1 text-xs font-medium text-[#111537]">
                                  Completion Date
                                </p>
                              </div>
                              <div className="w-[65%]">
                                <p className="py-1 text-xs font-medium text-[#606279]">
                                  : {item?.status || "None"}
                                </p>

                                <p className="py-1 text-xs font-medium text-[#606279]">
                                  :{" "}
                                  <span>
                                    <NuDate
                                      value={item?.submittedOn}
                                      format="DD-MMM-YYYY, "
                                    />
                                  </span>
                                  <span>
                                    <NuDate
                                      value={item?.submittedOn}
                                      format="hh:mm a"
                                    />
                                  </span>
                                </p>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      {GetAccess("survey_form_edit") &&
                        (GetRole() || isSubmittted) && (
                          <span
                            onClick={() =>
                              OpenEditForm(index, item?.id, item?.workingUser)
                            }
                            className={` ${
                              editLoading == true
                                ? "cursor-wait"
                                : "cursor-pointer"
                            }  md:mr-4 md:p-1 md:rounded-lg md:border w-auto h-auto mt-2 md:mt-0
                          ${
                            editModeIndex === index
                              ? "bg-green-100 border-green-500"
                              : "bg-red-100 border-red-500"
                          }`}
                          >
                            <EditIcon
                              color={editModeIndex === index ? "green" : "red"}
                              height={12}
                            />
                          </span>
                        )}
                      <span
                        onClick={() => handleToggle(index, surveyReportViewId)}
                        className={`cursor-pointer p-1 w-auto mt-2 md:mt-0 h-auto rounded-lg border transition flex items-center justify-center 
    ${
      expandedIndex === index
        ? "bg-blue-100 border-blue-500"
        : "bg-gray-100 border-gray-300"
    }`}
                      >
                        {expandedIndex === index ? (
                          <ToggleUp />
                        ) : (
                          <ToggleDown />
                        )}
                      </span>
                    </div>
                  </div>
                  {expandedIndex === index && (
                    <form onSubmit={formik.handleSubmit}>
                      {/* <CDynamicFormTwo
                         index={index}
                        formData={allForm?.titles || []}
                        expandedIndex={expandedIndex}
                        editModeIndex={editModeIndex}
                        allValue={allValue}
                        setAllValue={setAllValue}
                       /> */}
                      <CommonDynamicForm
                        formData={allForm?.titles || []}
                        formik={formik}
                        expandedIndex={expandedIndex}
                        index={index}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        SaveFormData={SaveFormData}
                        editModeIndex={editModeIndex}
                        FileAttachment={setFileList}
                        SignOne="Client"
                        SignTwo="Inspector"
                        setSignFunOne={setSignOne}
                        setSignFunTwo={setSignTwo}
                        allData={allForm}
                        setFileRemoveList={setFileRemoveList}
                        fileRemoveList={fileRemoveList}
                        setRemoveSignOne={setRemoveSignOne}
                        setRemoveSignTwo={setRemoveSignTwo}
                      />
                    </form>
                  )}
                </>
              );
            })}
          </div>
        }
        {allSubmitted && isSubmittted && otpEnable && (
          <div className="w-full  p-4 flex justify-end">
            <SubmitButton name="Verify with OTP" handleClick={handleSendOTP} />
          </div>
        )}
        {!otpEnable && isSubmittted && (
          <div className="w-full p-4 flex justify-end">
            <SubmitButton name="Verify" handleClick={handleEnableOTP} />
          </div>
        )}
      </div>
      {open && (
        <SendOTP
          surveyReportViewId={surveyReportViewId}
          onClose={() => setOpen(false)}
          fetchTasks={fetchTasks}
        />
      )}

      {openEnable && (
        <ModalContainer
          visiable={openEnable}
          title="Confirm"
          content={
            <div>
              <p>
                Are You Sure! You want to{" "}
                <span className="font-semibold">Verify</span> this Form?
              </p>
            </div>
          }
          handleClick={handleVerifyOTP}
          closeModal={() => setEnableOpen(false)}
          isLoading={loading}
        />
      )}

      {showErrorFeild && (
        <ModalContainer
          closeModal={() => setShowErrorFeild(false)}
          visiable={showErrorFeild}
          title=""
          hasButton={false}
          content={
            <div className=" max-w-[65vw] max-h-[90vh] min-h-[30vh]  min-w-[65vw] 2xl:min-w-[45vw]">
              <div className="w-full h-7 mb-2 flex justify-between items-center">
                <p className=" font-semibold text-sm">Feilds to be checked</p>
                <div className=" flex gap-4 items-center">
                  <button
                    className=" text-white bg-red-600"
                    onClick={() => {
                      setShowErrorFeild(false);
                      setErrorMessage("");
                    }}
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className=" w-full max-h-[calc(90vh-32px)] overflow-y-auto">
                <pre>{ErrorMessage}</pre>
              </div>
            </div>
          }
        />
      )}
    </SurveyReportLayout>
  );
}

export default FormSurvey;
